<template>
    <div v-if="showReschedule">
        <RescheduleClass :classInstanceId="classInstanceId" @back="showReschedule = false" @success="handleRescheduleSuccess" />
    </div>
    <div v-else>
        <div class="back-section flex flex-wrap align-self-start pt-2 justify-content-between w-full">
    <Button 
        icon="pi pi-arrow-left" 
        label="Back" 
        class="p-button-text Caption back-button mb-2"
        @click="$emit('back')" 
    />

    <div class="action-row flex flex-column md:flex-row gap-2 w-full md:w-auto">
        <Button 
            label="Reschedule Class" 
            class="orange-button-small mb-2 w-full md:w-auto" 
            @click="showReschedule = true" 
        />
        <Button
            :label="classDetails && classDetails.isPaid ? 'Payment Completed' : 'Complete Payment'"
            class="mb-2 mr-0 md:mr-4 w-full md:w-auto"
            size="small"
            :severity="classDetails && classDetails.isPaid ? 'contrast' : 'success'"
            :disabled="classDetails && classDetails.isPaid"
            @click="openPaymentDialog"
        />
    </div>
</div>
        <div v-if="loading" class="card flex justify-content-center">
            <ProgressSpinner />
        </div>
        <div v-else-if="classDetails" class="grid flex flex-column p-4">
            <h3 class="text-lg Paragraph-Medium mb-4">Class Details</h3>

            <div class="grid">
                <div class="col-12 md:col-6">
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Subject –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.subject) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Date –</span>
                        <span class="Paragraph-Regular">{{ classDetails.date }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Grade –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.grade) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Class Type –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.classType) }}</span>
                    </div>
                    <div class="detail-item meet-link-item" v-if="classDetails.meetLink">
                        <span class="Paragraph-Medium meet-link-label">Google Meet –</span>
                        <div class="meet-link-box">
                            <a :href="classDetails.meetLink" target="_blank" rel="noopener noreferrer" class="meet-link">{{ classDetails.meetLink }}</a>
                            <button class="copy-btn" @click="copyMeetLink(classDetails.meetLink)" :title="copied ? 'Copied!' : 'Copy link'">
                                <i :class="copied ? 'pi pi-check' : 'pi pi-copy'"></i>
                            </button>
                        </div>
                    </div>
                    <div class="detail-item" v-if="classDetails.classLocation">
                        <span class="Paragraph-Medium">Location –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.classLocation) }}</span>
                    </div>
                    <div class="detail-item text-justify" v-if="classDetails.areasToImprove">
                        <span class="Paragraph-Medium">Specific areas want to improve -</span>
                        <span class="Paragraph-Regular">{{ classDetails.areasToImprove }}</span>
                    </div>
                    <div class="detail-item text-justify" v-if="classDetails.note">
                        <span class="Paragraph-Medium">Additional Note –</span>
                        <span class="Paragraph-Regular">{{ classDetails.note }}</span>
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Language –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.language) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Time –</span>
                        <span class="Paragraph-Regular">{{ classDetails.start }} - {{ classDetails.end }}</span>
                    </div>

                    <div class="detail-item">
                        <span class="Paragraph-Medium">Class Model –</span>
                        <span class="Paragraph-Regular">{{ cleanupLables(classDetails.classModel) }}</span>
                    </div>
                    <div class="detail-item flex gap-2" v-if="classDetails.otherStudents && classDetails.otherStudents.length">
                        <span class="Paragraph-Medium whitespace-nowrap">Other Students –</span>
                        <div class="flex flex-column">
                            <span v-for="student in classDetails.otherStudents" :key="student" class="Paragraph-Regular">
                                {{ student }}
                            </span>
                        </div>
                    </div>
                    <div class="detail-item" v-if="classDetails.sessionFee != null">
                        <span class="Paragraph-Medium">Session Fee –</span>
                        <span class="Paragraph-Regular">{{ formatFee(classDetails.sessionFee) }}</span>
                    </div>
                    <div class="detail-item">
                        <span class="Paragraph-Medium">Payment –</span>
                        <span class="Paragraph-Regular">{{ classDetails.isPaid ? 'Completed' : 'Pending' }}</span>
                        <span class="Caption" v-if="!classDetails.isPaid">( Please complete your payment to unlock this session )</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <p>Could not load class details.</p>
        </div>
    </div>

    <Dialog v-model:visible="paymentDialog.visible" modal
        :header="paymentDialog.noCard ? 'Add a Payment Card' : (paymentDialog.payStatus === 'paid' ? 'Payment Completed' : 'Complete Payment')"
        :style="{ width: '26rem' }" :closable="!paymentDialog.paying" @hide="onPaymentDialogHide">
        <div v-if="paymentDialog.loading" class="flex justify-content-center align-items-center py-5">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: var(--orange-500);" />
        </div>
        <div v-else-if="paymentDialog.noCard" class="flex flex-column gap-3 py-3">
            <div class="flex align-items-start gap-3">
                <i class="pi pi-credit-card mt-1" style="font-size: 1.25rem; color: var(--orange-500);" />
                <p class="m-0 text-sm text-color-secondary">
                    You don't have a saved payment card yet, so this session charge can't be processed.
                    Please go to <b>Settings &rarr; Payment</b> and add a card before the session charges.
                </p>
            </div>
            <div class="flex justify-content-end gap-2 mt-2">
                <Button label="Not Now" icon="pi pi-times" class="p-button-text p-button-sm p-button-secondary" @click="paymentDialog.visible = false" />
                <Button label="Go to Settings" icon="pi pi-credit-card" class="red-button-small p-button-sm" @click="goToAddCard" autofocus />
            </div>
        </div>
        <div v-else-if="paymentDialog.details" class="flex flex-column gap-3 py-2">
            <div class="flex justify-content-between align-items-center">
                <span class="Caption text-color-secondary">Subject</span>
                <span class="Paragraph-Medium">{{ cleanupLables(paymentDialog.details.class?.subject) }}</span>
            </div>
            <div class="flex justify-content-between align-items-center">
                <span class="Caption text-color-secondary">Grade</span>
                <span class="Paragraph-Medium">{{ cleanupLables(paymentDialog.details.class?.grade) }}</span>
            </div>
            <div class="flex justify-content-between align-items-center">
                <span class="Caption text-color-secondary">Tutor</span>
                <span class="Paragraph-Medium">{{ paymentDialog.details.tutor?.name }}</span>
            </div>
            <Divider class="my-1" />
            <div class="flex justify-content-between align-items-center">
                <span class="Caption text-color-secondary">{{ paymentDialog.payStatus === 'paid' ? 'Amount Paid' : 'Amount Due' }}</span>
                <span class="Paragraph-Medium payment-amount">{{ formatCurrency(paymentDialog.details.payment?.classFee, paymentDialog.details.payment?.currency) }}</span>
            </div>

            <div v-if="paymentDialog.payStatus === 'paid'" class="flex align-items-center justify-content-center gap-2 mt-2 payment-success">
                <i class="pi pi-check-circle" />
                <span>Payment Completed</span>
            </div>
            <div v-else-if="paymentDialog.payStatus === 'pending'" class="flex align-items-center justify-content-center gap-2 mt-2 payment-pending-status">
                <i class="pi pi-spin pi-spinner" />
                <span>Processing payment...</span>
            </div>
            <div v-else-if="paymentDialog.error" class="mt-2 payment-error">
                {{ paymentDialog.error }}
            </div>

            <Button v-if="!paymentDialog.payStatus"
                :label="paymentDialog.paying ? 'Processing...' : 'Pay Now'"
                :disabled="paymentDialog.paying"
                :loading="paymentDialog.paying"
                severity="success"
                class="mt-2"
                @click="submitPayment" />
            <Button v-if="paymentDialog.payStatus === 'paid'" label="Close" severity="success" class="mt-2"
                @click="paymentDialog.visible = false" />
        </div>
    </Dialog>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits } from 'vue';
import { useRouter } from 'vue-router';
import { fetchClassInstanceDetails } from '@/api/student';
import { ProgressSpinner, Button, Divider, Dialog } from 'primevue';
import { notifyError } from '@/utils/notification';
import { cleanupLables } from "@/utils/cleanups";
import RescheduleClass from './RescheduleClass.vue';
import payments from "@/api/payments";

const props = defineProps({
    classInstanceId: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['back', 'payment-completed']);

const router = useRouter();

const goToAddCard = () => {
    paymentDialog.value.visible = false;
    router.push({ path: '/studentSettings', query: { tab: 'payment' } });
};

const loading = ref(true);
const classDetails = ref(null);
const showReschedule = ref(false);

const paymentDialog = ref({
    visible: false,
    loading: false,
    paying: false,
    noCard: false,
    details: null,
    payStatus: null,
    error: null,
});
let pollInterval = null;

const copied = ref(false);
const copyMeetLink = (link) => {
    navigator.clipboard.writeText(link);
    copied.value = true;
    setTimeout(() => { copied.value = false; }, 2000);
};

const formatFee = (fee) => `Rs.${Number(fee).toFixed(2)}`;

const formatCurrency = (amount, currency = 'LKR') => {
    if (amount == null) return '';
    return new Intl.NumberFormat('en-LK', { style: 'currency', currency }).format(amount);
};

const handleRescheduleSuccess = () => {
    showReschedule.value = false;
    fetchDetails();
};

const fetchDetails = async () => {
    try {
        loading.value = true;
        const response = await fetchClassInstanceDetails(props.classInstanceId);
        classDetails.value = response.data.data;
    } catch (error) {
        notifyError('Error fetching class details', error.message);
        console.error(error);
    } finally {
        loading.value = false;
    }
};

const openPaymentDialog = async () => {
    paymentDialog.value = { visible: true, loading: true, paying: false, noCard: false, details: null, payStatus: null, error: null };
    try {
        const res = await payments.getClassPaymentDetails(props.classInstanceId);
        const data = res.data?.data ?? res.data;
        if (data?.classInstance?.paymentStatus === 'paid') {
            paymentDialog.value.details = data;
            paymentDialog.value.payStatus = 'paid';
            if (classDetails.value) classDetails.value.paid = true;
        } else if (data?.student?.hasSavedCard === false) {
            paymentDialog.value.noCard = true;
        } else {
            paymentDialog.value.details = data;
        }
    } catch {
        paymentDialog.value.error = 'Failed to load payment details. Please try again.';
        paymentDialog.value.details = {};
    } finally {
        paymentDialog.value.loading = false;
    }
};

const startPolling = () => {
    pollInterval = setInterval(async () => {
        try {
            const res = await payments.getClassPaymentStatus(props.classInstanceId);
            const data = res.data?.data ?? res.data;
            const status = data?.classInstance?.paymentStatus ?? data?.status;
            if (status === 'paid') {
                clearInterval(pollInterval);
                paymentDialog.value.payStatus = 'paid';
                paymentDialog.value.paying = false;
                if (classDetails.value) classDetails.value.paid = true;
                emit('payment-completed', props.classInstanceId);
            } else if (status === 'failed') {
                clearInterval(pollInterval);
                paymentDialog.value.payStatus = null;
                paymentDialog.value.paying = false;
                paymentDialog.value.error = 'Payment failed. Please try again.';
            }
        } catch {
            clearInterval(pollInterval);
            paymentDialog.value.paying = false;
            paymentDialog.value.error = 'Could not verify payment status. Please refresh.';
        }
    }, 4000);
};

const submitPayment = async () => {
    paymentDialog.value.paying = true;
    paymentDialog.value.error = null;
    try {
        const res = await payments.payForClass(props.classInstanceId);
        const data = res.data?.data ?? res.data;
        if (data?.requiresTokenization) {
            paymentDialog.value.paying = false;
            paymentDialog.value.noCard = true;
            paymentDialog.value.details = null;
        } else if (data?.status === 'paid') {
            paymentDialog.value.payStatus = 'paid';
            paymentDialog.value.paying = false;
            if (classDetails.value) classDetails.value.paid = true;
            emit('payment-completed', props.classInstanceId);
        } else if (data?.status === 'pending') {
            paymentDialog.value.payStatus = 'pending';
            startPolling();
        } else {
            paymentDialog.value.paying = false;
            paymentDialog.value.error = 'Unexpected response. Please try again.';
        }
    } catch (err) {
        paymentDialog.value.paying = false;
        paymentDialog.value.error = err?.response?.data?.message ?? 'Payment failed. Please try again.';
    }
};

const onPaymentDialogHide = () => {
    if (pollInterval) {
        clearInterval(pollInterval);
        pollInterval = null;
    }
};

onMounted(() => {
    fetchDetails();
});
</script>

<style scoped>
.detail-item {
    margin-bottom: 1rem;
}

.detail-item span {
    display: inline-block;
    margin-right: 1rem;
}

.payment-amount {
    font-size: 1.1rem;
    color: var(--green-600);
}

.payment-success {
    color: var(--green-600);
    font-size: 0.9rem;
}

.payment-pending-status {
    color: var(--orange-500);
    font-size: 0.9rem;
}

.payment-error {
    color: var(--red-500);
    font-size: 0.85rem;
    text-align: center;
}

.meet-link-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.meet-link-label {
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 0 !important;
}

.meet-link-box {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
/** background: #eff6ff;
    border: 1px solid #bfdbfe; */
    border-radius: 8px;
    padding: 0.2rem 0.4rem;
    max-width: 100%;
    min-width: 0;
}

.meet-link {
    color: #3b82f6;
    text-decoration: none;
    font-size: 0.82rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.meet-link:hover {
    text-decoration: underline;
    color: #2563eb;
}

.copy-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: transparent;
    color: #93c5fd;
    border: none;
    border-radius: 4px;
    padding: 0;
    font-size: 0.8rem;
    cursor: pointer;
    flex-shrink: 0;
    transition: color 0.15s;
}

.copy-btn:hover {
    color: #3b82f6;
}

.copy-btn .pi-check {
    color: #22c55e;
}

@media (max-width: 768px) {
    .detail-item {
        display: flex;
        flex-wrap: wrap;
        gap: 0.35rem;
    }

    .detail-item span {
        margin-right: 0;
    }

    .meet-link-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.35rem;
    }

    .meet-link-label {
        white-space: normal;
    }

    .meet-link-box {
        width: 100%;
    }

    .meet-link {
        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
    }
}
</style>